// extracted by mini-css-extract-plugin
module.exports = {"chatLinkText":"ChatLink_chatLinkText__2_hIr","chatLink":"ChatLink_chatLink__3-Wkx"};